/**
 * @file
 * Highlights JS.
 *
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.product_kits = {
    attach: function (context, settings) {
      //$('.paragraph--type--highlight-carousel .field--name-field-highlight .field--name-field-title', context).matchHeight();
      var $block = $('.field--name-field-product-kit', context);
      if($block.length) {
        $block.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 5000,
          useAutoplayToggleButton: false,
          speed: 300,
          arrows: true,
          dots: false,
          infinite: true,
          swipe: true,
          responsive: [
            {
              breakpoint: 5500,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 720,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      }
    }
  };


})(jQuery, Drupal);
